import { createFileRoute } from "@tanstack/react-router";
import ContentPage from "@/components/contentPage";
import DataAssetSearchAssetList from "@/components/dataAsset/dataAssetSearchAssetList";
import { dataAssetSearchSchema } from "@/schemas/dataAssetSearchSchema";

export const Route = createFileRoute("/data/assets/search")({
  component: DataAssetSearch,
  validateSearch: dataAssetSearchSchema,
});

function DataAssetSearch() {
  return (
    <ContentPage title={"Data Asset Search"}>
      <DataAssetSearchAssetList />
    </ContentPage>
  );
}
